import * as Effect from "effect/Effect";
import * as Random from "effect/Random";

/**
 * Configuration for exponential reconnect backoff.
 */
export interface ReconnectBackoffConfig {
  /** Base delay in milliseconds before the first retry. */
  readonly initialDelayMs: number;
  /** Multiplier applied per retry (exponential factor). */
  readonly backoffFactor: number;
  /** Hard upper bound on delay in milliseconds. */
  readonly maxDelayMs: number;
  /** Maximum number of retries (0-based). `null` means unlimited. */
  readonly maxRetries: number | null;
}

export const DEFAULT_RECONNECT_BACKOFF: ReconnectBackoffConfig = {
  initialDelayMs: 1_000,
  backoffFactor: 2,
  maxDelayMs: 64_000,
  maxRetries: 7,
};

export function getReconnectDelayMs(
  retryIndex: number,
  config: ReconnectBackoffConfig = DEFAULT_RECONNECT_BACKOFF,
): number | null {
  if (!Number.isInteger(retryIndex) || retryIndex < 0) {
    return null;
  }

  if (config.maxRetries !== null && retryIndex >= config.maxRetries) {
    return null;
  }

  const ceiling = Math.min(
    config.initialDelayMs * config.backoffFactor ** retryIndex,
    config.maxDelayMs,
  );
  return Math.round(ceiling * (0.5 + Effect.runSync(Random.next) * 0.5));
}
